import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

export const Caiman = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/caiman-1.png" size={size} alt="caiman" />
)
